import * as axios from "~/utilities/axios"

export const getClientToken = (sessionToken, type, stripeVersion) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/payments/tokenization/getEphemeralKey?type=${type}&stripeVersion=${stripeVersion}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getBasicBraintreeClientToken = () => {
  return axios
    .secure()
    .get(`/api/v1/payments/braintree/token`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getDefaultPaymentMethodToken = (sessionToken, userEmail) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/payments/braintree/token-card/${userEmail}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getDefaultPaymentMethodBin = (sessionToken, userEmail) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/payments/braintree/token-bin/${userEmail}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getPaymentMethodBin = (sessionToken, userEmail, paymentMethodToken) => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/payments/braintree/token-bin-for-payment-method/${paymentMethodToken}/${userEmail}`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getDefaultPaymentMethod = sessionToken => {
  return axios
    .secure(sessionToken)
    .get(`/api/v1/payments/savedMethods/default`)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getAllPaymentMethods = sessionToken => {
  return axios
      .secure(sessionToken)
      .get(`/api/v1/payments/savedMethods/all`)
      .then(res => res.data)
      .catch(axios.parseError)
}

export const syncPaymentMethod = (paymentMethodToken, sessionToken, userEmail) => {
  const data = {
    token: paymentMethodToken,
    userEmail,
  }
  return axios
    .secure(sessionToken)
    .post(`${process.env.PARSE_DIR}/functions/syncPaymentMethod`, data)
    .then(res => res.data.result)
    .catch(axios.parseError)
}

export const updateDefaultPaymentMethodForCko = (paymentMethodToken, sessionToken, userEmail) => {
  const data = {
    token: paymentMethodToken,
    userEmail,
  }
  return axios
      .secure(sessionToken)
      .post(`${process.env.PARSE_DIR}/functions/updateDefaultPaymentMethodForCko`, data)
      .then(res => res.data.result)
      .catch(axios.parseError)
}

export const getAllEVSavedPaymentMethods = (sessionToken, userEmail) => {
  return axios
      .secure(sessionToken)
      .get(`/evervault/getAllSavedPaymentMethods/${userEmail}`)
      .then(res => res.data)
      .catch(axios.parseError)
}

export const chargeTrafficTicket = (objectId, ticketID, sessionToken) => {
  const data = {
    ticketID,
    objectId,
  }
  return axios
    .secure(sessionToken)
    .post(`${process.env.PARSE_DIR}/functions/chargeTrafficTicket`, data)
    .then(res => res.data.result)
    .catch(axios.parseError)
}

export const chargePaymentPlanDownPayment = (paymentPlan, sessionToken) => {
  const data = {
    paymentPlanId: paymentPlan.objectId,
    paymentPlanDP: paymentPlan.downPayment
  }
  return axios
      .secure(sessionToken)
      .post(`${process.env.PARSE_DIR}/functions/chargePaymentPlanDownPayment`, data)
      .then(res => res.data.result)
      .catch(axios.parseError)
}

export const savePersistedApplicationState = async (state, ckoSessionId) => {
  let result
  try {
    result = await axios
      .secure()
      .post(`${process.env.PRIMARY_API_URL}/api/v1/payments/persistedState`, {
        state: JSON.stringify(state),
        ckoSessionId,
      })
  } catch (error) {
    console.error(error)
    return false
  }

  if (result.status !== 200) {
    return false
  }

  return true
}

export const getPersistedApplicationState = async (sessionId) => {
  let result

  try {
    result = await axios.secure().get(`${process.env.PRIMARY_API_URL}/api/v1/payments/persistedState/${sessionId}`)
  } catch (error) {
    console.error(error)
    return false
  }

  if (result.status !== 200) {
    return false
  }
  return JSON.parse(result.data.state)
}

export const getChargeRequestStatusAfter3DSChallengeForCko = async (sessionToken, userEmail, ckoSessionId, flowType) => {
  const data = {
    ckoSessionId,
    userEmail,
    flowType,
  }
  return axios
      .secure(sessionToken)
      .post(`${process.env.PARSE_DIR}/functions/getChargeRequestStatusForCko`, data)
      .then(res => res.data.result)
      .catch(axios.parseError)
}

export const shouldUserBeEvervaulted = async (sessionToken, userEmail) => {
  return axios
      .secure(sessionToken)
      .get(`/evervault/shouldUserBeEvervaulted/${userEmail}`)
      .then(res => res.data)
      .catch(axios.parseError)
}

export const preAuthorizeChargeEvByCardValues = async (
  sessionToken,
  userEmail,
  userPhoneNumber,
  ticketIds,
  source,
  cardholderFirstName,
  cardholderLastName,
  cardNumberAlias,
  cardExpDate,
  cardCvcAlias,
  cardBrand,
  billingAddressLine1,
  billingAddressCity,
  billingAddressState,
  billingAddressZip,
  billingAddressCountry,
  firstPlateNumber,
  gclid,
  gclidCapturedAt
) => {
  const data = {
    userEmail,
    userPhoneNumber,
    ticketIds,
    source,
    cardholderFirstName,
    cardholderLastName,
    cardNumberAlias,
    cardExpDate,
    cardCvcAlias,
    cardBrand,
    billingAddressLine1,
    billingAddressCity,
    billingAddressState,
    billingAddressZip,
    billingAddressCountry,
    firstPlateNumber,
    // Google click id captured at the parking ad click (deterministic attribution).
    ...(gclid ? { gclid } : {}),
    ...(gclidCapturedAt ? { gclidCapturedAt } : {})
  }
  return axios
    .secure(sessionToken)
    .post(`/evervault/outboundPreAuthorize/`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}

export const preAuthorizeChargeEvByCardId = async (
    sessionToken,
    userEmail,
    userPhoneNumber,
    ticketIds,
    source,
    cardId,
    cardCvc,
    firstPlateNumber,
    gclid,
    gclidCapturedAt
) => {
  const data = {
    userEmail,
    userPhoneNumber,
    ticketIds,
    source,
    cardId,
    cardCvc,
    firstPlateNumber,
    // Google click id captured at the parking ad click (deterministic attribution).
    ...(gclid ? { gclid } : {}),
    ...(gclidCapturedAt ? { gclidCapturedAt } : {})
  }
  return axios
      .secure(sessionToken)
      .post(`/evervault/outboundPreAuthorize/`, data)
      .then(res => res.data)
      .catch(axios.parseError)
}

export const queueCityPayPaymentWhenSocketIsDown = (
    sessionToken,
    cityPaySessionId,
) => {
  const data = {
    cityPaySessionId,
    cityPayBotTimeout: process.env.CITYPAY_BOT_TIMEOUT * 1000,
  }
  return axios
      .secure(sessionToken)
      .put(`/evervault/queuePaymentAfterTimeout`, data)
      .then(res => res.data)
      .catch(axios.parseError)
}

/**
 * Charge a group of guilty parking tickets
 * @param {Array<string>} objectIds Array of object ids
 * @param {string} [nonce] Braintree 3DS verified nonce
 * @param {string} sessionToken Users session token
 */
export const chargeParkingTickets = (flowType, objectIds, nonce, sessionToken, source, isPaymentMethodJustAdded, userEmail, cardScheme) => {
  const data = {
    flowType,
    objectIds,
    nonce,
    source,
    isPaymentMethodJustAdded,
    userEmail,
    cardScheme
  }
  return axios
    .secure(sessionToken)
    .post(`${process.env.PARSE_DIR}/functions/processManyPayment`, data)
    .then(res => res.data.result)
    .catch(axios.parseError)
}

export const finalize3DSChallengeStripe = async (ticketIds, userEmail, paymentIntentId, status, stripeResponse) => {
  const data = {
    ticketIds,
    paymentIntentId,
    status,
    stripeResponse,
    userEmail
  }
  return axios
    .secure()
    .post(`${process.env.PARSE_DIR}/functions/finalizeStripePaymentAfter3DS`, data)
    .then(res => res.data.result)
    .catch(axios.parseError)
}

/**
 * Charge an individual parking ticket
 * @param {string} ticketID ticket objectId to charge
 * @param {string} [nonce] Braintree 3DS verified nonce
 * @param {string} sessionToken Users session token
 */
export const chargeParkingTicket = (ticketID, nonce, sessionToken) => {
  const data = {
    ticketID,
    nonce,
  }
  return axios
    .secure(sessionToken)
    .post(`${process.env.PARSE_DIR}/functions/processPayment`, data)
    .then(res => res.data.result)
    .catch(axios.parseError)
}

/**
 * Get the final charge amount for a series of guilty tickets
 * @param {Array<string>} objectIds Array of object ids
 * @param {string} sessionToken Users session token
 * @param {Array<string>} source Which domain is making the request
 */
export const getParkingGuiltyChargeAmount = (objectIds, sessionToken, source, userEmail) => {
  return axios
    .secure(sessionToken)
    .post(`/api/v1/parkingticket/amountToBeCharged/`, { objectIds, source, userEmail })
    .then(res => res.data)
    .catch(axios.parseError)
}

/**
 * Get service fee and additional fee per ticket for parking pay flow
 * @param {string} sessionToken Users session token
 * @param {Array<string>} source Which domain is making the request
 */
export const getParkingFees = (sessionToken, source, amountToBeCharged, isUserEverVault = false) => {
  return axios
    .secure(sessionToken)
    .post(`/api/v1/parking/pricing/`, { source, amount: amountToBeCharged, isUserEverVault })
    .then(res => res.data)
    .catch(axios.parseError)
}

export const getSessionStatusFromCKO = () => {
  return axios
    .secure()
    .post("/api/v1/cko/ckoEvents")
    .then((res) => {
      return res.data
    })
    .catch(axios.parseError)
}

export const overwritePaymentProcessor = async (user, locationState) => {
  return axios.
    secure()
    .put('/api/v1/payments/paymentProcessor/overwritePaymentProcessor', { user, locationState })
    .then(res => res.data)
    .catch(axios.parseError)
}

/**
 * Create a setup intent for stripe ACH
 */
export const createSetupIntent = () => {
  return axios
    .secure()
    .post(`api/v1/payments/ach/createSetupIntent`)
    .then((res) => res.data)
    .catch(axios.parseError)
}

/**
 * Charge payment plan down payment via ACH
 * @param {object} paymentPlan Payment plan object
 */
export const chargePaymentPlanDownPaymentACH = (paymentPlanId, paymentMethodId, sessionToken) => {
  const data = {
    paymentPlanId,
    paymentMethodId,
  }
  return axios
    .secure(sessionToken)
    .post(`/api/v1/payments/ach/chargePaymentPlanDownPaymentACH`, data)
    .then(res => res.data)
    .catch(axios.parseError)
}
